module.exports = __webpack_public_path__ + "static/media/ico-chevron.6195cf62.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/ico-chevron.svg
// module id = 253
// module chunks = 8